import React from 'react';

interface TourProgressProps {
  currentStep: number;
  totalSteps: number;
  onStepClick?: (stepIndex: number) => void;
}

const TourProgress: React.FC<TourProgressProps> = ({
  currentStep,
  totalSteps,
  onStepClick,
}) => {
  const steps = Array.from({ length: totalSteps }, (_, index) => index);

  const handleStepClick = (stepIndex: number) => {
    if (onStepClick && stepIndex <= currentStep) {
      onStepClick(stepIndex);
    }
  };

  return (
    <div className="tour-progress" role="progressbar" aria-valuemax={totalSteps} aria-valuenow={currentStep + 1}>
      {steps.map((stepIndex) => (
        <button
          key={stepIndex}
          className={`tour-progress-dot ${stepIndex === currentStep ? 'active' : ''} ${
            stepIndex < currentStep ? 'completed' : ''
          } ${stepIndex <= currentStep ? 'clickable' : ''}`}
          onClick={() => handleStepClick(stepIndex)}
          disabled={stepIndex > currentStep || !onStepClick}
          aria-label={`Step ${stepIndex + 1} ${
            stepIndex === currentStep ? '(current)' : stepIndex < currentStep ? '(completed)' : ''
          }`}
        />
      ))}
    </div>
  );
};

export default TourProgress;